<template>
  <div>
    <Form
      ref="addModel"
      :model="addModel"
      :rules="ruleValidate"
      :label-width="100"
    >
      <FormItem label="服务" prop="DicId">
        <Select v-model="addModel.DicId">
          <Option
            v-for="(item, index) in ServiceSelect"
            :value="item.dictionaryID"
            :key="index"
            >{{ item.dictionaryValue }}
          </Option>
        </Select>
      </FormItem>
      <FormItem label="xml配置" prop="xmlinfo">
        <Input
          v-model="addModel.xmlinfo"
          placeholder="请输入xml配置"
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 10 }"
        ></Input>
      </FormItem>
    </Form>
    <Upload
      ref="uploadFile"
      :action="uploadUrl"
      :headers="headers"
      :on-success="uploadSuccess"
      :on-error="uploadError"
    >
      <!-- :show-upload-list="false" -->
      <Button icon="ios-cloud-upload-outline">选择压缩包</Button>
    </Upload>

    <div class="text-center modal-foter">
      <Button @click="returnBack" class="mr-5">取 消</Button>
      <Button type="success" @click="handleSubmit('addModel')"
        >确 定</Button
      >
    </div>
  </div>
</template>
<script>
import organTree from "../../basedata/organ/organTree.vue";
import token from "../../../utils/token.js";
export default {
  components: { organTree },
  data: function () {
    return {

      fileName: "",
      headers: "",
      uploadUrl: "",
      ServiceSelect: [],
      addModel: {
        DicId: "",
        DicName: "",
        DicCode: "",
        xmlinfo:"",
        UpdateFilePath: "",
      },
      SecretTypeSelect: [],
      ruleValidate: {
        VersionName: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        VersionCode: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        DicName: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        UpdateFilePath: [
          {
            required: true,
            message: "不能为空",
          },
        ],
      },
    };
  },

  created: function () {
    let baseUrl = localStorage.getItem("baseURL");
    this.uploadUrl = baseUrl + "/clientversion/uploadrar";
    this.headers = { Authorization: "Bearer " + token.getToken() };

    this.$common.getDictionaryByCode("9001").then((data) => {
      this.ServiceSelect = data;
    });
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },

    handleSubmit: function (from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          this.$api.post("serviceInfo/create", this.addModel).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("添加成功");
              this.returnBack();
              this.resetData();
              this.$emit("loadData");
            }
          });
        }
      });
    },

    resetData() {
      for (let key in this.addModel) {
        this.addModel[key] = "";
      }
      this.$refs["addModel"].resetFields();
    },
    

  

    //导入
    uploadSuccess: function (response, file, fileList) {
      if (response.statusCode == 200) {
        this.$Message.success("上传成功");
        this.addModel.UpdateFilePath = response.data;
        this.fileName = file.name;
      } else {
        this.$Message.success(response.msg);
      }
    },

    cancel: function () {},
    uploadError: function (error, file, fileList) {
      this.$Message.success("上传失败");
    },
  },
};
</script>
<style scoped>
.limitshow {
  max-width: 10em;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>